<template>
  <v-container grid-list-xs>
    <v-overlay :value="overlay2">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row dense align-content="center" justify="center">
      <v-col cols="12" md="12" xs="12">
        <v-row class="mt-2">
          <v-spacer style="border-top: 1px solid #bbb; margin-top: 24px;"></v-spacer>
          <v-chip
           class="ma-2"
           color="#BDE7D9"
           label
          >
            <h2 style="color: #27AB9C; font-weight: bold; font-size: 1.25rem;" class="pt-3">{{header}}</h2>
          </v-chip>
          <v-spacer style="border-top: 1px solid #bbb; margin-top: 24px;"></v-spacer>
        </v-row>
      </v-col>
    </v-row>
    <v-row justify="start" class="pt-12"  v-if="AllProduct.length !== 0 && !MobileSize && !IpadSize">
      <v-col cols="12" md="2" sm="3" xs="4" v-for="(item, index) in paginated" :key="index">
        <CardProducts :itemProduct='item' />
      </v-col>
    </v-row>
    <v-row justify="start" class="pt-12"  v-if="AllProduct.length !== 0 && !MobileSize && IpadSize">
      <v-col cols="12" md="2" sm="3" xs="6" v-for="(item, index) in paginated" :key="index">
        <CardProducts :itemProduct='item' />
      </v-col>
    </v-row>
    <v-row justify="start" class="pt-12"  v-if="AllProduct.length !== 0 && MobileSize && !IpadSize">
      <v-col cols="6" md="6" sm="6" xs="6" v-for="(item, index) in paginated" :key="index">
        <CardProductsResponsive :itemProduct='item' />
      </v-col>
    </v-row>
    <v-row justify="center" class="my-6">
      <v-pagination
       color="#27AB9C"
       v-model="pageNumber"
       :length="pageMax"
       :total-visible="7"
       @change="pageChange()"
      ></v-pagination>
    </v-row>
  </v-container>
</template>

<script>
import { Decode } from '@/services'
const FakeData = []
for (let i = 0; i < 48; i++) {
  FakeData.push({
    product_id: i,
    name: `Data Title newArrivals ${i}`,
    price: ` ${i * 10}`,
    stock: `${i}`,
    image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
  })
}
export default {
  components: {
    CardProducts: () => import('@/components/Card/ProductCardUI'),
    CardProductsResponsive: () => import('@/components/Card/ProductCardResponsive')
  },
  data () {
    return {
      seller_shop_id: '',
      shopPosition: '',
      header: '',
      FakeData,
      overlay2: false,
      productCount: null,
      AllProduct: [],
      pageMax: null,
      current: 1,
      pageSize: 48,
      shopID: null,
      typeproduct: ''
    }
  },
  created () {
    this.oneData = []
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        var userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
        var shop = userDetailSelling
        this.seller_shop_id = shop.seller_shop_id
        this.shopPosition = shop.position
      }
    }
    this.$EventBus.$emit('getPath')
    this.header = this.$router.currentRoute.params.data
    // this.pageNumber = parseInt(this.$route.query.pageNumber)
    if (this.header === 'สินค้ามาใหม่') {
      this.typeproduct = 'new_product'
      this.$EventBus.$on('getAllNewProduct', this.getAllNewProduct)
      this.getAllNewProduct()
    } else if (this.header === 'สินค้าขายดี') {
      this.typeproduct = 'best_seller'
      this.$EventBus.$on('getAllBestSeller', this.getAllBestSeller)
      this.getAllBestSeller()
    } else if (this.header === 'สินค้าแนะนำ') {
      this.typeproduct = 'recommended_product'
      this.$EventBus.$on('getAllSameProductShop', this.getAllSameProductShop)
      this.shopID = localStorage.getItem('shopID')
      this.getAllSameProductShop()
    } else if (this.header === 'สินค้าจากร้านเดียวกัน') {
      this.typeproduct = 'new_product'
      this.$EventBus.$on('getAllProductShop', this.getAllProductShop)
      this.getAllProductShop()
    } else if (this.header === 'สินค้าทั้งหมด') {
      this.typeproduct = 'all_product'
      this.$EventBus.$on('getAllProductShop', this.getAllProductShop)
      this.getAllProductShop()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  // computed: {
  //   pageNumber: {
  //     get () {
  //       return parseInt(this.$route.query.pageNumber) || 1
  //     },
  //     set (newPage) {
  //       this.$router.push(`/ListProductUI/${this.header}?pageNumber=${newPage}`).catch(() => {})
  //     }
  //   }
  // },
  computed: {
    pageNumber: {
      get () {
        return this.current || 1
      },
      set (newPage) {
        // You could alternatively call your API here if you have serverside pagination
        this.current = newPage
        window.scrollTo(0, 0)
      }
    },
    indexStart () {
      return (this.current - 1) * this.pageSize
    },
    indexEnd () {
      return this.indexStart + this.pageSize
    },
    paginated () {
      return this.AllProduct.slice(this.indexStart, this.indexEnd)
    },
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  methods: {
    async getAllBestSeller () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        type: 'best-seller',
        category_id: -1,
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      await this.$store.dispatch('actionsGraczProductList', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      // console.log('response all Best Seller =======>', response)
      if (response.result === 'success') {
        if (response.data.products.length !== 0) {
          this.overlay2 = false
          this.AllProduct = []
          this.AllProduct = response.data.products
          this.pageMax = parseInt(this.AllProduct.length / 48) === 0 ? 1 : Math.ceil(this.AllProduct.length / 48)
          // console.log('pageMax ===>', this.pageMax, this.AllProduct.length)
          this.productCount = response.data.count_product
        } else {
          this.overlay2 = false
          this.AllProduct = []
          this.productCount = 0
        }
      } else {
        const Toast = this.$swal.mixin({
          showConfirmButton: false,
          timer: 1500
        })
        Toast.fire({
          icon: 'error',
          title: `${response.message}`
        })
      }
    },
    async getAllSameProductShop () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        type: 'recommend',
        category_id: -1,
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      await this.$store.dispatch('actionsGraczProductList', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      // console.log('response all Best Seller =======>', response)
      if (response.result === 'success') {
        this.overlay2 = false
        this.AllProduct = []
        this.AllProduct = response.data.products
        // this.AllProduct = response.data.list_new_products
        this.pageMax = parseInt(this.AllProduct.length / 48) === 0 ? 1 : Math.ceil(this.AllProduct.length / 48)
        // console.log('pageMax ===>', this.pageMax, this.AllProduct.length)
        this.productCount = response.data.count_product
      } else {
        this.overlay2 = false
        this.AllProduct = []
        this.productCount = 0
        const Toast = this.$swal.mixin({
          showConfirmButton: false,
          timer: 1500
        })
        Toast.fire({
          icon: 'error',
          title: `${response.message}`
        })
      }
    },

    async getAllProductShop () {
      var data = {
        seller_shop_id: this.seller_shop_id,
        type: 'all',
        category_id: -1,
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      await this.$store.dispatch('actionsGraczProductList', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      // console.log('response Shop Detail Page =======>', response)
      if (response.result === 'success') {
        if (response.data.products.length !== 0) {
          this.overlay2 = false
          this.AllProduct = []
          this.AllProduct = response.data.products
          // this.AllProduct = response.data.list_new_products
          this.pageMax = parseInt(this.AllProduct.length / 48) === 0 ? 1 : Math.ceil(this.AllProduct.length / 48)
          // console.log('pageMax ===>', this.pageMax, this.AllProduct.length)
          this.productCount = response.data.count_product
        }
      } else {
        this.overlay2 = false
        this.AllProduct = []
        this.productCount = 0
        const Toast = this.$swal.mixin({
          showConfirmButton: false,
          timer: 1500
        })
        Toast.fire({
          icon: 'error',
          title: `${response.message}`
        })
      }
    },
    async getAllNewProduct () {
      var data
      data = {
        seller_shop_id: this.seller_shop_id,
        type: 'new',
        category_id: -1,
        role_user: this.shopPosition,
        cus_id: -1,
        page: 1,
        order_price: null
      }
      await this.$store.dispatch('actionsGraczProductList', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczProductList
      if (response.message === 'Not access this function.') {
        await this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      }
      // console.log('response all New product=======>', response)
      if (response.result === 'success') {
        if (response.data.products.length !== 0) {
          this.overlay2 = false
          this.AllProduct = []
          this.AllProduct = response.data.products
          this.pageMax = parseInt(this.AllProduct.length / 48) === 0 ? 1 : Math.ceil(this.AllProduct.length / 48)
          // console.log('pageMax ===>', this.pageMax, this.AllProduct.length)
          this.productCount = response.data.count_product
        } else {
          this.overlay2 = false
          this.AllProduct = []
          this.productCount = 0
        }
      } else {
        const Toast = this.$swal.mixin({
          showConfirmButton: false,
          timer: 1500
        })
        Toast.fire({
          icon: 'error',
          title: `${response.message}`
        })
      }
    }
  }
}
</script>

<style>

</style>
